<template>
  <div class="wrapper">
    <b-row>
      <b-col>
        <b-card header="Users">
        <div class="filter-bar ui basic segment grid">
          <div class="ui form">
            <div class="inline field">
              <label>Search for:</label>
              <input type="text" v-model="filterText" class="three wide column" @keyup.enter="doFilter" placeholder="email, permission">
              <button class="ui primary button" @click="doFilter">Go</button>
              <button class="ui button" @click="resetFilter">Reset</button>
            </div>
          </div>
        </div>
        <vuetable :multi-sort="true" multi-sort-key="ctrl" ref="vuetable" :api-url="api_url" :fields="fields" pagination-path="" :per-page="perPage" @vuetable:pagination-data="onPaginationData" :append-params="moreParams" :http-options="httpOptions" >
          <template slot="actions" slot-scope="props">
            <div class="table-button-container">
              <button class="btn btn-info" @click="editUser(props.rowData)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
              <button class="btn btn-danger" @click="deleteUser(props.rowData._id)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
            </div>
          </template>
        </vuetable>
        <div class="vuetable-pagination ui basic segment grid">
          <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
          <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
        </div>
        </b-card>
        <b-card header="Add a new User">
          <form action="#" method="POST" class="createUser">
            <div class="form-group">
              <label>User Email:</label>
              <input class="form-control" type="email" placeholder="Ex: editor@axl.media" required="required" v-model="email">
            </div>
            <div class="form-group">
              <label>User Permissions: (1) - Publisher, (2) - Editor, (3) - Admin</label>
              <input class="form-control" type="number" placeholder="Ex: 1, 2 or 3" required="required" v-model="permission">
            </div>
            <div class="form-group">
              <label>Password:</label>
              <input class="form-control" type="text" placeholder="Ex: incorrect" required="required" v-model="password">
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-secondary form-control" @click.prevent="saveUser">Save</button>
            </div>
          </form>
        </b-card>
      </b-col>
    </b-row>
    <edit-user-modal></edit-user-modal>
  </div>
</template>

<script>

import Vue from 'vue'
import { Bus } from '@/main'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import EditUserModal from '@/views/modals/EditUserModal'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    'edit-user-modal': EditUserModal
  },
  data () {
    return {
      httpOptions: {
        baseURL: this.$http.defaults.baseURL,
        headers: this.$http.defaults.headers.common
      },
      perPage: 10,
      cmpName: '',
      cmpDescription: '',
      cmpCode: '',
      moreParams: {},
      campaignmakerCode: '',
      filterText: '',
      email: '',
      password: '',
      permission: '',

      fields: [
        {
          name: '__sequence', // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },
        {
          name: 'email',
          title: 'Email',
          sortField: 'email'
        },
        {
          name: 'permission',
          title: 'Permission',
          sortField: 'permission',
          callback: 'formatPermission'
        },
        {
          name: 'created_at',
          title: 'Created',
          sortField: 'created_at',
          callback: 'formatDate'
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }

      ],
      api_url: '',
      sortOrder: [
        {
          field: 'created_at',
          sortField: 'created_at',
          direction: 'desc'
        }
      ]
    }
  },
  methods: {
    formatPermission (value) {
      let permission
      if (value === 0) {
        permission = 'Guest'
      }
      if (value === 1) {
        permission = 'User'
      }
      if (value === 2) {
        permission = 'Editor'
      }
      if (value === 3) {
        permission = 'Admin'
      }
      return permission
    },
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value === null)
        ? ''
        : this.$moment(value, 'YYYY-MM-DD').format(fmt)
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData) // <----
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    saveUser () {
      if (this.email && this.permission && this.password) {
        this.$http.post(`${this.$api_url}/users/create`, { email: this.email, permission: this.permission, password: this.password }).then((success, error) => {
          if (success) {
            this.reloadTable()
            this.email = ''
            this.permission = ''
            this.password = ''
          }
          if (error) {
            alert('Duplicate User Email!')
          }
        })
      }
    },
    reloadTable () {
      this.$refs.vuetable.refresh()
    },
    deleteUser (id) {
      if (prompt('Are you sure? Type "delete" if yes!') === 'delete') {
        this.$http.delete(`${this.$api_url}/users/delete/${id}`, { id: id }).then((success) => {
          this.reloadTable()
          alert('User deleted!')
        })
      } else {
        alert('User not deleted!')
      }
    },
    editUser (data) {
      Bus.$emit('editUser', data)
      this.$bvModal.show('user-edit')
    },
    doFilter () {
      this.moreParams = {
        filter: this.filterText
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    resetFilter () {
      this.moreParams = {}
      this.filterText = ''
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    }
  },
  created () {
    this.api_url = this.$api_url + '/users'
    Bus.$on('userUpdated', () => {
      this.reloadTable()
    })
  },
  beforeDestroy () {
    Bus.$off('userUpdated')
  }
}
</script>
